var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1592 0H1.82583C1.3396 0 0.873279 0.193153 0.529462 0.536969C0.185645 0.880786 -0.00750732 1.3471 -0.00750732 1.83333V16.5C-0.00750732 16.9862 0.185645 17.4525 0.529462 17.7964C0.873279 18.1402 1.3396 18.3333 1.82583 18.3333H20.1592C20.6454 18.3333 21.1117 18.1402 21.4555 17.7964C21.7993 17.4525 21.9925 16.9862 21.9925 16.5V1.83333C21.9925 1.3471 21.7993 0.880786 21.4555 0.536969C21.1117 0.193153 20.6454 0 20.1592 0ZM21.0758 16.5C21.0758 16.7431 20.9792 16.9763 20.8073 17.1482C20.6354 17.3201 20.4023 17.4167 20.1592 17.4167H1.82583C1.58271 17.4167 1.34957 17.3201 1.17766 17.1482C1.00575 16.9763 0.909159 16.7431 0.909159 16.5V5.92167L10.0758 11.2063L10.9925 11.7379L11.9092 11.2063L21.0758 5.90792V16.5ZM21.0758 4.85375L10.9925 10.6792L0.909159 4.86291V1.83333C0.909159 1.59022 1.00575 1.35706 1.17766 1.18515C1.34957 1.01324 1.58271 0.916667 1.82583 0.916667H20.1592C20.4023 0.916667 20.6354 1.01324 20.8073 1.18515C20.9792 1.35706 21.0758 1.59022 21.0758 1.83333V4.85375Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19918 15.5833H5.94918C6.07073 15.5833 6.18731 15.535 6.27326 15.4491C6.35922 15.3631 6.40751 15.2465 6.40751 15.125C6.40751 15.0034 6.35922 14.8869 6.27326 14.8009C6.18731 14.715 6.07073 14.6667 5.94918 14.6667H3.19918C3.07762 14.6667 2.96105 14.715 2.87509 14.8009C2.78914 14.8869 2.74084 15.0034 2.74084 15.125C2.74084 15.2465 2.78914 15.3631 2.87509 15.4491C2.96105 15.535 3.07762 15.5833 3.19918 15.5833Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_1646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18.3333,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.97afa10aa8c554d3a7571bdda5a47078.svg";
export { ForwardRef as ReactComponent };